import React, { PropsWithChildren, createContext, useContext } from "react";
import { VariantProps } from "class-variance-authority";
import { card } from "./CardStyle";

interface CardContextState extends VariantProps<typeof card> {}

export const CardContext = createContext<CardContextState | undefined>(
  undefined
);

export const useCardContext = () => {
  const context = useContext(CardContext);
  if (context === undefined) {
    throw new Error("useCardContext must be used within a CardProvider");
  }
  return context;
};

export const CardProvider = (props: PropsWithChildren<CardContextState>) => {
  const { children, ...rest } = props;
  return <CardContext.Provider value={rest}>{children}</CardContext.Provider>;
};
